import React, { type JSX } from 'react';
import EgnaLokalaQuery from './AnalysEgnaLokalaQuery.gql';
import {
  AnalysEgnaLokalaQuery as IData,
  AnalysEgnaLokalaQueryVariables as IVariables,
} from './_QueryTypes/AnalysEgnaLokalaQuery';
import { useQuery } from '@apollo/client';

interface IProps {
  dbname: string;
  endastAnvandarens: boolean;
  children: (analysNamn: IEgenLokalAnalys[], loading: boolean) => JSX.Element;
}

export interface IEgenLokalAnalys {
  namn: string;
  id: string;
}

const AnalysEgnaLokalaQuery: React.FunctionComponent<IProps> = props => {
  const queryResult = useQuery<IData, IVariables>(EgnaLokalaQuery, {
    variables: {
      dbname: props.dbname,
      endast_anvandarens: props.endastAnvandarens,
    },
    fetchPolicy: 'cache-and-network',
  });

  if (!queryResult.data) {
    return props.children([], queryResult.loading);
  }

  const data = queryResult.data;

  if (!data.ekanalysegnalokala) {
    return props.children([], queryResult.loading);
  }

  return props.children(data.ekanalysegnalokala, queryResult.loading);
};

export default AnalysEgnaLokalaQuery;
